import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async get() {
        try
        {            
            const response = await axios.get(`Company`,
            {
                headers: {
                    'page_key': pageKeys.company_account
                }
            })            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.post(`Company`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_account
                }
            })        
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async updateClockInOutSettings(data) {
        try
        {            
            const response = await axios.post(`Company/clockinout`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.workdays
                }
            })        
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getWorkDays() {
        try {
           
            const response = await axios.get(`Company/workdays`,
            {
                headers: {
                    'page_key': pageKeys.workdays
                }
            })                        
            return response;  
        }
        catch (error) {
            throw error
        }
    },
    async updateWorkDays(data) {
        try {
            const response = await axios.post(`Company/workdays`,{
                items: data
            },
            {
                headers: {
                    'page_key': pageKeys.workdays
                }
            }) 
            return response;  
        }
        catch (error) {
            throw error
        }
    },
    async getIndustries() {
        try {
           
            const response = await axios.get(`Company/industries`,
            {
                headers: {
                    'page_key': pageKeys.company_account
                }
            })                        
            return response;  
        }
        catch (error) {
            throw error
        }
    },
    async getLinkedAccounts() {
        try
        {            
            const response = await axios.get(`Company/linked-accounts`,
            {
                headers: {
                    'page_key': pageKeys.company_linked_account
                }
            })            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getLinkedAccount(companyId) {
        try
        {            
            const response = await axios.get(`Company/linked-accounts/${companyId}`,
            {
                headers: {
                    'page_key': pageKeys.company_linked_account
                }
            })            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async addLinkedAccountUser(data) {
        try
        {            
            const response = await axios.post(`Company/linked-accounts/user`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_linked_account
                }
            })            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async deleteLinkedAccountUser(data) {
        try
        {            
            const response = await axios.post(`Company/linked-accounts/delete/user`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_linked_account
                }
            })            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
}